<template>
  <div class="w-full h-full pt-10 px-6 pb-8 box-border overflow-hidden">
    <el-steps direction="vertical" space="300px" :active="2" finish-status="process" class="ars-steps">
      <el-step title="创建样本群组，并在群组中添加收信人">
        <span slot="icon">1</span>
        <div slot="description">
          <div class="my-4">
            <el-button size="small" type="primary" @click="toCreateSampleGroup">创建样本群组</el-button>
          </div>
          <div class="text-medium text-theme-black-650">
            创建样本群组后，请&nbsp;
            <span class="text-theme cursor-pointer select-none" @click="$emit('refresh')">刷新</span>
            &nbsp;本页面
          </div>
        </div>
      </el-step>
      <el-step title="选择样本群组中的收件人，定向发布短信">
        <span slot="icon">2</span>
        <div slot="description"></div>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
import GlobalConfig from '@/global/config'
import { getSurveyDomain } from '@/assets/js/config/env'

export default {
  name: 'AddRecipientStep',
  methods: {
    toCreateSampleGroup() {
      /* const tenantId = GlobalConfig.getTenantId()
      const token = GlobalConfig.getToken()
      const base_token = GlobalConfig.getBaseToken()
      const joinStr = Object.entries({ tenantId, token, base_token })
        .map(([key, value]) => `${key}=${value}`)
        .join('&')
      const url = `${getSurveyDomain()}/sample-company?${joinStr}` */
      const url = `${getSurveyDomain()}/entrance?token=${GlobalConfig.getToken()}#/sample-manager/sample-company`
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.ars-steps {
  ::v-deep .el-step.is-vertical {
    .el-step__head {
      @apply w-5;
    }
    .el-step__line {
      height: calc(100% - 32px);
      top: 26px;
      left: 9px;
    }
    .el-step__icon {
      @apply w-5 h-5 bg-ccc text-white;
      &.is-text {
        @apply border-0;
      }
    }
    .el-step__title {
      @apply font-medium text-medium-x;
      line-height: 18px;
      &.is-process {
        @apply text-black opacity-85;
      }
    }
  }
}
</style>
